import Header from "./components/Header";
import Hero from "./components/Hero";
import CertLogos from "./components/CertLogos";
import WhySouthAfrica from "./components/WhySouthAfrica";
import Products from "./components/Products";
import Channels from "./components/Channels";
import Certifications from "./components/Certifications";
import Logistics from "./components/Logistics";
import Markets from "./components/Markets";
import About from "./components/About";
import QuoteForm from "./components/QuoteForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-cream">
      <Header />
      <Hero />
      <CertLogos />
      <WhySouthAfrica />
      <Products />
      <Channels />
      <Certifications />
      <Logistics />
      <Markets />
      <About />
      <QuoteForm />
      <Footer />
    </main>
  );
}